"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
const _ = __importStar(require("lodash"));
const vue_property_decorator_1 = require("vue-property-decorator");
const vue_class_component_1 = require("vue-class-component");
const core_1 = require("@integro/core");
let BulkRentalServiceEditor = class BulkRentalServiceEditor extends (0, vue_class_component_1.mixins)(core_1.UserComponentMixin) {
    componentMetadata = {
        kind: "page",
    };
    beforeCreate() {
    }
    getItemFromInput(...args) {
        const [inputItems, fields] = args;
        const fieldNames = _.map(fields, 'name');
        let result = {};
        _.each(inputItems, (item, i) => {
            if (i === 0) {
                result = _.pick(item, fieldNames);
            }
            for (const { name, defaultValue } of fields) {
                if (result[name] != item[name]) {
                    result[name] = defaultValue;
                    continue;
                }
                if (_.isUndefined(result[name])) {
                    result[name] = defaultValue;
                    continue;
                }
                if (result[name] != null) {
                    result[name] = item[name];
                }
            }
        });
        result['$updates'] = _.reduce(fieldNames, (m, v) => _.set(m, v, false), {});
        return result;
    }
    getPayload(...args) {
        const [inputItems, item] = args;
        const updates = _.keys(_.pickBy(item.$updates, _.identity));
        if (!updates.length) {
            return;
        }
        const update = _.pick(item, updates);
        return {
            items: _.map(inputItems, item => ({
                id: item.id,
                etag: item.etag,
                value: update
            }))
        };
    }
    items;
    onItems(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("items");
    }
    size;
    onSize(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("size");
    }
    editableFields;
    labelAlign;
    formId;
    async $$load_formId() {
        return this.$fn.randomElementId();
    }
    formName;
    item;
    async $$load_item() {
        return this.getItemFromInput(this.items, this.$data.editableFields);
    }
    services;
    async $$load_services() {
        return this.$fn.fetch('suggest_product', {
            parameters: { query: '*', top: 50, skip: 0, product_types: 'service', product_invoice_groups: 'all' }
        }).then(data => _.orderBy(data, [p => p.name.toLowerCase()]));
    }
    tariffs;
    async $$load_tariffs() {
        return this.$app.repo.get('list_object_by_type', { parameters: { object_type: 'tariff' } });
    }
    units;
    async $$load_units() {
        return this.$fn.fetch('list_unit').then(d => _.orderBy(d, [p => p.symbol.toLowerCase()]));
    }
    invoiceGroups;
    async $$load_invoiceGroups() {
        return this.$fn.fetch('list_product_invoice_group');
    }
    ux;
    b_7315092382398562_modalBindings;
    b_3468003412020058_dataSource;
    dataMembers = ['editableFields', 'labelAlign', 'formId', 'formName', 'item', 'services', 'tariffs', 'units', 'invoiceGroups', 'ux', 'b_7315092382398562_modalBindings', 'b_3468003412020058_dataSource'];
    data() {
        return {
            ...this.mixinData(),
            actions: this.getActions(),
            ...{
                editableFields: [{
                        name: "service",
                    },
                    {
                        name: "name",
                    },
                    {
                        name: "billing_unit",
                    },
                    {
                        name: "invoice_notes",
                    },
                    {
                        name: "invoice_notes",
                    },
                    {
                        name: "valid_from",
                    },
                    {
                        name: "valid_to",
                    },
                    {
                        name: "tariff_code",
                    },
                    {
                        name: "meter_factor",
                    },
                    {
                        name: "intermediated_service",
                    },
                    {
                        name: "inflation_indexed",
                    },
                    {
                        name: "notes",
                    },
                ],
                labelAlign: "right",
                formId: null,
                formName: "BulkRentalServiceEditor",
                item: null,
                services: null,
                tariffs: null,
                units: null,
                invoiceGroups: null,
                ux: null,
                b_7315092382398562_modalBindings: {
                    size: "lg",
                },
                b_3468003412020058_dataSource: {
                    name: "suggest_product",
                    parameters: {
                        product_types: "service",
                    },
                },
            },
        };
    }
    get document() {
        if (this.loaded) {
            return {
                title: this.$fn.pgettext("BulkRentalServiceEditor", "Edit Service Properties"),
            };
        }
        return null;
    }
    async act_7315092382398562_closeModal_9678_getActionArgs($event) {
        return {
            name: this.modalName,
            result: {
                close: true,
                cancel: true,
            },
        };
    }
    async evh_7315092382398562_close(event, scope) {
        return await this.actions.evh_7315092382398562_close.executeFromDOM(this, event, scope);
    }
    async evh_2248226175642056_close(event, scope) {
        return await this.actions.evh_2248226175642056_close.executeFromDOM(this, event, scope);
    }
    async act_1040167445267876_closeModal_9684_getActionArgs($event) {
        return {
            result: {
                ok: true,
            },
        };
    }
    async act_1040167445267876_request_9682_getActionArgs($event) {
        return {
            operation: "bulk_update_rental_service",
            data: this.getPayload(this.items, this.item),
        };
    }
    async evh_1040167445267876_submit(event, scope) {
        return await this.actions.evh_1040167445267876_submit.executeFromDOM(this, event, scope);
    }
    async act_3468003412020058_setData_9686_getActionArgs($event) {
        return {
            path: "item.service_id",
            value: this.item.service.id,
            resolve: false,
            noTouchLastLoaded: false,
            noTakeSnapshot: false,
        };
    }
    async act_3468003412020058_setData_9688_getActionArgs($event) {
        return {
            path: "item.name",
            value: $event.data.option.name,
            resolve: false,
            noTouchLastLoaded: false,
            noTakeSnapshot: false,
        };
    }
    async evh_3468003412020058_optionSelected(event, scope) {
        return await this.actions.evh_3468003412020058_optionSelected.executeFromDOM(this, event, scope);
    }
    async evh_1419464017721962_clickPreventStop(event, scope) {
        return await this.actions.evh_1419464017721962_clickPreventStop.executeFromDOM(this, event, scope);
    }
    actions;
    getActions() {
        const act_7315092382398562_closeModal_9678 = new core_1.actions.CloseModalAction({
            actionArgs: this.act_7315092382398562_closeModal_9678_getActionArgs,
            events: [],
        });
        const evh_7315092382398562_close_9677 = new core_1.actions.EventHandlerImpl({
            action: act_7315092382398562_closeModal_9678,
            event: "close",
            displayName: "closeModal",
        });
        const evh_7315092382398562_close = new core_1.actions.EventHandlerGroup({
            handlers: [evh_7315092382398562_close_9677],
        });
        const act_2248226175642056_closeComponent_9680 = new core_1.actions.CloseComponentAction({
            events: [],
        });
        const evh_2248226175642056_close_9679 = new core_1.actions.EventHandlerImpl({
            action: act_2248226175642056_closeComponent_9680,
            event: "close",
            displayName: "closeComponent",
        });
        const evh_2248226175642056_close = new core_1.actions.EventHandlerGroup({
            handlers: [evh_2248226175642056_close_9679],
        });
        const act_1040167445267876_closeModal_9684 = new core_1.actions.CloseModalAction({
            actionArgs: this.act_1040167445267876_closeModal_9684_getActionArgs,
            events: [],
        });
        const evh_1040167445267876_success_9683 = new core_1.actions.EventHandlerImpl({
            action: act_1040167445267876_closeModal_9684,
            event: "success",
            displayName: "closeModal",
        });
        const act_1040167445267876_request_9682 = new core_1.actions.RequestAction({
            actionArgs: this.act_1040167445267876_request_9682_getActionArgs,
            displayName: "save",
            events: [evh_1040167445267876_success_9683],
        });
        const evh_1040167445267876_submit_9681 = new core_1.actions.EventHandlerImpl({
            action: act_1040167445267876_request_9682,
            event: "submit",
            displayName: "save",
        });
        const evh_1040167445267876_submit = new core_1.actions.EventHandlerGroup({
            handlers: [evh_1040167445267876_submit_9681],
        });
        const act_3468003412020058_setData_9686 = new core_1.actions.SetDataAction({
            actionArgs: this.act_3468003412020058_setData_9686_getActionArgs,
            events: [],
        });
        const evh_3468003412020058_optionSelected_9685 = new core_1.actions.EventHandlerImpl({
            action: act_3468003412020058_setData_9686,
            event: "optionSelected",
            displayName: "setData",
        });
        const act_3468003412020058_setData_9688 = new core_1.actions.SetDataAction({
            actionArgs: this.act_3468003412020058_setData_9688_getActionArgs,
            events: [],
        });
        const evh_3468003412020058_optionSelected_9687 = new core_1.actions.EventHandlerImpl({
            action: act_3468003412020058_setData_9688,
            event: "optionSelected",
            displayName: "setData",
        });
        const evh_3468003412020058_optionSelected = new core_1.actions.EventHandlerGroup({
            handlers: [evh_3468003412020058_optionSelected_9685, evh_3468003412020058_optionSelected_9687],
        });
        const act_1419464017721962_closeComponent_9690 = new core_1.actions.CloseComponentAction({
            events: [],
        });
        const evh_1419464017721962_clickPreventStop_9689 = new core_1.actions.EventHandlerImpl({
            action: act_1419464017721962_closeComponent_9690,
            event: "click.prevent.stop",
            displayName: "closeComponent",
        });
        const evh_1419464017721962_clickPreventStop = new core_1.actions.EventHandlerGroup({
            handlers: [evh_1419464017721962_clickPreventStop_9689],
        });
        return {
            act_7315092382398562_closeModal_9678,
            evh_7315092382398562_close_9677,
            evh_7315092382398562_close,
            act_2248226175642056_closeComponent_9680,
            evh_2248226175642056_close_9679,
            evh_2248226175642056_close,
            act_1040167445267876_closeModal_9684,
            evh_1040167445267876_success_9683,
            act_1040167445267876_request_9682,
            evh_1040167445267876_submit_9681,
            evh_1040167445267876_submit,
            act_3468003412020058_setData_9686,
            evh_3468003412020058_optionSelected_9685,
            act_3468003412020058_setData_9688,
            evh_3468003412020058_optionSelected_9687,
            evh_3468003412020058_optionSelected,
            act_1419464017721962_closeComponent_9690,
            evh_1419464017721962_clickPreventStop_9689,
            evh_1419464017721962_clickPreventStop,
            save: act_1040167445267876_request_9682,
        };
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({
        required: true,
        type: Array,
    }),
    __metadata("design:type", typeof (_a = typeof array !== "undefined" && array) === "function" ? _a : Object)
], BulkRentalServiceEditor.prototype, "items", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('items'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], BulkRentalServiceEditor.prototype, "onItems", null);
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: String,
        default: "lg",
    }),
    __metadata("design:type", String)
], BulkRentalServiceEditor.prototype, "size", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('size'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], BulkRentalServiceEditor.prototype, "onSize", null);
BulkRentalServiceEditor = __decorate([
    (0, vue_property_decorator_1.Component)()
], BulkRentalServiceEditor);
exports.default = BulkRentalServiceEditor;
vue_property_decorator_1.Vue.component("BulkRentalServiceEditor", BulkRentalServiceEditor);
